import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FiUploadCloud, FiX } from "react-icons/fi";

const ContentControllerForm = ({ onSubmit, onCancel, initialData = null }) => {
  const [form, setForm] = useState({
    title: "",
    shortDescription: "",
    fullDescription: "",
  });
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    if (initialData) {
      setForm({
        title: initialData.title || "",
        shortDescription:
          initialData.shortDescription || initialData.title || "",
        fullDescription: initialData.fullDescription || "",
      });
      setImagePreview(initialData.imageUrl || null);
    } else {
      setForm({ title: "", shortDescription: "", fullDescription: "" });
      setImage(null);
      setImagePreview(null);
    }
  }, [initialData]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleImage = (file) => {
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const removeImage = () => {
    setImage(null);
    setImagePreview(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ ...form, image });
  };

  return (
    <motion.form
      className="banner-form"
      onSubmit={handleSubmit}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="form-grid">
        <div className="form-item">
          <label>Sarlavha *</label>
          <input
            name="title"
            value={form.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-item">
          <label>Qisqa izoh *</label>
          <input
            name="shortDescription"
            value={form.shortDescription}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-item full-width">
          <label>To‘liq matn *</label>
          <textarea
            name="fullDescription"
            rows="8"
            value={form.fullDescription}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-item full-width">
          <label>Asosiy rasm *</label>
          <div className="image-upload-box">
            {imagePreview ? (
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  src={imagePreview}
                  alt="Tanlangan rasm"
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "cover",
                    borderRadius: "14px",
                    display: "block",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  }}
                />
                <motion.button
                  whileHover={{ scale: 1.15 }}
                  whileTap={{ scale: 0.9 }}
                  type="button"
                  onClick={removeImage}
                  style={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                    background: "rgba(220, 38, 38, 0.9)",
                    color: "white",
                    border: "none",
                    width: 38,
                    height: 38,
                    borderRadius: "50%",
                    fontSize: 20,
                    cursor: "pointer",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                  }}
                >
                  ×
                </motion.button>
              </div>
            ) : (
              <motion.div
                className="upload-placeholder"
                whileHover={{ scale: 1.03, backgroundColor: "#f0f7ff" }}
                whileTap={{ scale: 0.97 }}
                onClick={() => document.getElementById("imgInput").click()}
                style={{
                  height: "280px",
                  border: "3px dashed #cbd5e1",
                  borderRadius: "16px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#f8fafc",
                  cursor: "pointer",
                  gap: 12,
                }}
              >
                <FiUploadCloud size={52} color="#6366f1" />
                <p
                  style={{
                    margin: 0,
                    fontSize: 17,
                    fontWeight: 600,
                    color: "#374151",
                  }}
                >
                  Rasm yuklash uchun bosing
                </p>
                <span style={{ fontSize: 14, color: "#94a3b8" }}>
                  JPG, PNG • Maks 10MB
                </span>
              </motion.div>
            )}
            <input
              id="imgInput"
              type="file"
              accept="image/*"
              hidden
              onChange={(e) => handleImage(e.target.files[0])}
              required={!initialData}
            />
          </div>
        </div>

        <div className="form-buttons">
          <button type="submit" className="save">
            {initialData ? "Yangilash" : "Qo‘shish"}
          </button>
          <button type="button" className="cancel" onClick={onCancel}>
            Bekor qilish
          </button>
        </div>
      </div>
    </motion.form>
  );
};

export default ContentControllerForm;
